import type { DirectiveBinding } from 'vue'

function bindHint(el: HTMLElement, binding: DirectiveBinding) {
  const message = binding.value

  if (message) {
    el.setAttribute('title', message)
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('hint', {
    mounted: bindHint,
    updated: bindHint,
  })
})
